const DEFAULT_PAYMENTS_FILTERS = {
  company: '',
  dateFrom: null,
  dateTo: null,
  type: '',
};

export default DEFAULT_PAYMENTS_FILTERS;
